import React from 'react';

export interface BlockInnerTextProps {
  pre_title: string;
  title: string;
  title_size?: TitleSize;
  text: string;
}

export const BlockInnerText: React.FC<BlockInnerTextProps> = ({
  pre_title,
  title,
  title_size,
  text,
}) => {
  return (
    <div className='inner-text'>
      <div className='inner-text__pre-title'>{pre_title}</div>
      <h2
        className='inner-text__title'
        style={
          {
            '--title-size-desktop': `${title_size?.desktop || '2.0'}rem`,
            '--title-size-mobile': `${title_size?.mobile || '1.0'}rem`,
          } as React.CSSProperties
        }
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p
        className='inner-text__text'
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    </div>
  );
};
